// extracted by mini-css-extract-plugin
export default {"component":"WRbU9","with-border":"YskNe","background-main":"Ysod9","background-secondary":"asNre"};